import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { PING_PLAYBACK_CAMERA } from '../../../constants/service.types';
import { socketEmitEvent } from '../../../redux/actions';

export const usePingPlayback = ({
  serial,
  namespace,
  isPlayingRef,
  playbackStreamRef,
}) => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (!serial || !namespace) return;
    const intervalId = setInterval(() => {
      if (!isPlayingRef.current) return;
      const dataBody = { serial, namespace, control: null };
      if (playbackStreamRef.current?.supportGateways) {
        dataBody.supportGateways = playbackStreamRef.current.supportGateways;
      }
      dispatch(
        socketEmitEvent({
          appServiceType: PING_PLAYBACK_CAMERA,
          requestId: new Date().getTime(),
          body: JSON.stringify(dataBody),
        }),
      );
    }, 10000);
    return () => clearInterval(intervalId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [serial, namespace]);
};
